import type { EdgeId } from '@ipfabric/utils';
import type { GraphData } from 'components/Graph/model/GraphData';

/**
 * Get edge IDs from packet IDs to prevent highlighting terminated packets.
 */
export const filterOutNonEdgePackets =
  (graph: GraphData) =>
  (followingPacketIds: EdgeId[] | null): EdgeId[] | null =>
    followingPacketIds?.filter((edgeId) => graph.edges[edgeId] !== undefined) ??
    null;
